import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const BoletoEnabledSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3850" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_3850)"
      />
      <Path
        d="M11.75 8C11.5511 8 11.3603 8.07902 11.2197 8.21967C11.079 8.36032 11 8.55109 11 8.75V15.25C11 15.4489 11.079 15.6397 11.2197 15.7803C11.3603 15.921 11.5511 16 11.75 16C11.9489 16 12.1397 15.921 12.2803 15.7803C12.421 15.6397 12.5 15.4489 12.5 15.25V8.75C12.5 8.55109 12.421 8.36032 12.2803 8.21967C12.1397 8.07902 11.9489 8 11.75 8Z"
        fill="black"
      />
      <Path
        d="M16.25 8H14.75C14.3358 8 14 8.33579 14 8.75V15.25C14 15.6642 14.3358 16 14.75 16H16.25C16.6642 16 17 15.6642 17 15.25V8.75C17 8.33579 16.6642 8 16.25 8Z"
        fill="black"
      />
      <Path
        d="M19.25 8C19.0511 8 18.8603 8.07902 18.7197 8.21967C18.579 8.36032 18.5 8.55109 18.5 8.75V15.25C18.5 15.4489 18.579 15.6397 18.7197 15.7803C18.8603 15.921 19.0511 16 19.25 16C19.4489 16 19.6397 15.921 19.7803 15.7803C19.921 15.6397 20 15.4489 20 15.25V8.75C20 8.55109 19.921 8.36032 19.7803 8.21967C19.6397 8.07902 19.4489 8 19.25 8Z"
        fill="black"
      />
      <Path
        d="M24.25 8H22.25C21.8358 8 21.5 8.33579 21.5 8.75V15.25C21.5 15.6642 21.8358 16 22.25 16H24.25C24.6642 16 25 15.6642 25 15.25V8.75C25 8.33579 24.6642 8 24.25 8Z"
        fill="black"
      />
      <Path
        d="M8.75 8C8.55109 8 8.36032 8.07902 8.21967 8.21967C8.07902 8.36032 8 8.55109 8 8.75V15.25C8 15.4489 8.07902 15.6397 8.21967 15.7803C8.36032 15.921 8.55109 16 8.75 16C8.94891 16 9.13968 15.921 9.28033 15.7803C9.42098 15.6397 9.5 15.4489 9.5 15.25V8.75C9.5 8.65151 9.4806 8.55398 9.44291 8.46299C9.40522 8.37199 9.34997 8.28931 9.28033 8.21967C9.21069 8.15003 9.12801 8.09478 9.03701 8.05709C8.94602 8.0194 8.84849 8 8.75 8Z"
        fill="black"
      />
      <Path
        d="M27.25 8C27.0511 8 26.8603 8.07902 26.7197 8.21967C26.579 8.36032 26.5 8.55109 26.5 8.75V15.25C26.5 15.4489 26.579 15.6397 26.7197 15.7803C26.8603 15.921 27.0511 16 27.25 16C27.4489 16 27.6397 15.921 27.7803 15.7803C27.921 15.6397 28 15.4489 28 15.25V8.75C28 8.55109 27.921 8.36032 27.7803 8.21967C27.6397 8.07902 27.4489 8 27.25 8Z"
        fill="black"
      />
    </Svg>
  )
}
